import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Moon, Sun } from "lucide-react";
import { useTheme, type Theme } from "@/contexts/ThemeContext";
import { SettingsSection } from "@/components/settings/SettingsSection";
import { ThemePreview } from "./ThemePreview";

const themes: { id: Theme; name: string }[] = [
  { id: "default", name: "Default" },
  { id: "writer", name: "Writer" },
  { id: "paper", name: "Paper" },
  { id: "solarised", name: "Solarized" },
  { id: "forest", name: "Forest" },
  { id: "ayu", name: "Ayu" },
];

export function ThemeSelector() {
  const { theme, mode, setTheme, toggleMode } = useTheme();
  const isDarkMode = mode === "dark";

  return (
    <div className="space-y-6">
      <SettingsSection
        title="Color mode"
        description="Light or dark for the current theme."
      >
        <div className="flex items-center justify-between rounded-xl border border-border px-4 py-3">
          <Label
            htmlFor="dark-mode-toggle"
            className="flex cursor-pointer items-center gap-2 font-normal"
          >
            {isDarkMode ? (
              <Moon className="h-4 w-4 text-muted-foreground" />
            ) : (
              <Sun className="h-4 w-4 text-muted-foreground" />
            )}
            <span>{isDarkMode ? "Dark" : "Light"}</span>
          </Label>
          <Switch
            id="dark-mode-toggle"
            checked={isDarkMode}
            onCheckedChange={toggleMode}
          />
        </div>
      </SettingsSection>

      <SettingsSection
        title="Theme"
        description="Colour palette for the app chrome and editor highlighting."
      >
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {themes.map((themeOption) => (
            <ThemePreview
              key={themeOption.id}
              themeId={themeOption.id}
              themeName={themeOption.name}
              onClick={() => setTheme(themeOption.id)}
              isActive={theme === themeOption.id}
            />
          ))}
        </div>
      </SettingsSection>
    </div>
  );
}
